<div
  *ngIf="control"
  #container
  [style.min-height.px]="minRows*12"
  [class.row]="inline"
  [style.display]="(type === 'checkbox' || type === 'switch-checkbox') && centerCheckbox ? 'flex' : 'auto'"
  [style.align-items]="(type === 'checkbox' || type === 'switch-checkbox') && centerCheckbox ? 'end' : 'unset'"
>
  <label  class="form-label "
          *ngIf="(type !== 'checkbox' && type !== 'switch-checkbox') && label && !labelCheckboxEnabler"
          [class.col-form-label]="inline"
          [class.col-sm-3]="inline"
          [class.col-form-label-sm]="inline && small"
          [for]="name"
  >{{ label }} <span class="ps-2" *ngIf="inputCounter">{{ $any(control).value?.length ?? '0' }}
    /{{ inputCounterMax }}</span>

    <ng-container *ngIf="tooltipText">
      <span><i [tooltip]="tooltipText" class="fa fa-info-circle"></i></span>
    </ng-container>
  </label>

  <label
    *ngIf="(type !== 'checkbox' && type !== 'switch-checkbox') && label && labelCheckboxEnabler"
    class="form-label"
    [class.col-form-label]="inline"
    [class.col-sm-3]="inline"
    [class.col-form-label-sm]="inline && small"
    [for]="name"
  >
    <div>
      <input class="form-check-input" type="checkbox" (click)="toggleFormState()" [checked]="control.enabled" [id]="name + '_label_checkbox'">
      <label class="form-check-label ps-2" [for]="name + '_label_checkbox'">
        {{ label }}
      </label>
    </div>
  </label>

  <div [class.col-sm-9]="inline">
    <div class="input-group"  >
    <span *ngIf="prefix" class="input-group-text">
      {{ prefix }}
    </span>

      <input
        [autocomplete]="autocomplete"
        [formControl]="$any(control)"
        [id]="name"
        [tabindex]="tabindex"
        [required]="control.hasValidator(requiredValidator)"
        [autofocus]="autofocus"
        [type]="showPassword ? 'text' : type"
        class="form-control"
        [class.form-control-sm]="small"
        *ngIf="['text', 'password', 'email'].includes(type)"
        [class.is-invalid]="(control.enabled && control.touched && !control.valid) || !!control.getError('serverError')"
        [class.is-valid]="control.touched && control.valid"
        [maxlength]="inputCounterMax ?? null"
        [placeholder]="placeholder"
      />

      <input
        [autocomplete]="autocomplete"
        [formControl]="$any(control)"
        (colorPickerChange)="control.setValue($event)"
        [style.background-color]="control.getRawValue()"
        [colorPicker]="control.getRawValue()"
        [id]="name"
        [required]="control.hasValidator(requiredValidator)"
        [autofocus]="autofocus"
        class="form-control has-validation"
        [tabindex]="tabindex"

        *ngIf="['color'].includes(type)"
        [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
        [class.is-valid]="control.touched && control.valid"
        [maxlength]="inputCounterMax ?? null"
        [placeholder]="placeholder"
      />

      <input
        [autocomplete]="autocomplete"
        [formControl]="$any(control)"
        [id]="name"
        [required]="control.hasValidator(requiredValidator)"
        [type]="showPassword ? 'text' : type"
        [autofocus]="autofocus"
        class="form-control"
        [tabindex]="tabindex"
        [class.form-control-sm]="small"
        *ngIf="['number'].includes(type)"
        [class.is-invalid]="(control.enabled && control.touched && !control.valid)|| !!control.getError('serverError')"
        [class.is-valid]="control.touched && control.valid"
        [pattern]="numberPattern"
        [min]="numberMin !== undefined ? numberMin : null"
        [attr.max]="numberMax !== undefined ? numberMax : null"
        [placeholder]="placeholder"
      />

      <input [formControl]="$any(control)"
             *ngIf="['readonly'].includes(type)"
             [id]="name"
             class="form-control"
             [value]="control.getRawValue() | convertFormValueToReadOnlyDisplay"
             type="text"
             [tabindex]="tabindex"
             [class.form-control-sm]="small"
             [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
             [class.is-valid]="control.touched && control.valid"
             readonly
             [placeholder]="placeholder"
      >

      <textarea
        [id]="name"
        [tabindex]="tabindex"
        [required]="control.hasValidator(requiredValidator)"
        class="form-control"
        [autofocus]="autofocus"
        [class.form-control-sm]="small"
        autosize
        [minRows]="minRows"
        *ngIf="['textarea'].includes(type)"
        [formControl]="$any(control)"
        [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
        [class.is-valid]="control.touched && control.valid"
        [placeholder]="placeholder"
      ></textarea>


      <quill-editor
        class="d-grid w-100"
        #content
        [formControl]="$any(control)"
        *ngIf="['textarea-html'].includes(type)"
        [class.is-invalid]="!!control.getError('serverError')"
        [modules]="{
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ header: 1 }, { header: 2 }],
          [{ list: 'ordered' }, { list: 'bullet' }],

          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ['link'],
          ['clean']
        ]
      }"

        format="html"

        [bounds]="container"
        [sanitize]="false"
        theme="snow"
        [placeholder]="placeholder"

      ></quill-editor>

      <div class="form-check"
           [class.form-switch]="type === 'switch-checkbox'"
           [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
           *ngIf="type === 'checkbox' || type === 'switch-checkbox'"
      >
        <input type="checkbox" class="form-check-input"
               [formControl]="$any(control)"
               [id]="name"
               [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
               [class.is-valid]="control.touched && control.valid"
               [class.disabled]="control.disabled"
        />
        <label class="form-check-label ps-2" [for]="name">{{ label }}</label>
      </div>

      <ng-container *ngIf="type === 'radio'" >

        <div class="form-check me-3" *ngFor="let option of selectOptions; let i = index">
          <input type="radio" class="form-check-input "

                 [formControl]="$any(control)"
                 [id]="name + '-' + i"
                 [value]="option.value"

                 [name]="radioGroupName"
                 [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
                 [class.is-valid]="control.touched && control.valid"
                 [class.disabled]="control.disabled"
          />
          <label class="form-check-label" [for]="name + '-' + i">{{ option.key }}</label>
        </div>
      </ng-container>

      <select *ngIf="type === 'select' && !multi"
              class="form-control"
              [class.form-control-sm]="small"
              [id]="label"
              [formControl]="control"
              [class.disabled]="control.disabled"
              [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
              [class.is-valid]="control.touched && control.valid"
      >
        <option *ngIf="placeholder" [value]="null" disabled hidden><span class="text-muted">{{ placeholder }}</span>
        </option>
        <option *ngIf="!placeholder" [value]="null" disabled hidden></option>
        <option *ngIf="!placeholder" [value]="undefined" disabled hidden></option>
        <option *ngFor="let option of selectOptions; let i = index"
                [value]="option.value"
                [selected]="control.value === option.value"
                [disabled]="option.disabled === true">
          {{ option.key }}
        </option>


      </select>

      <ng-multiselect-dropdown
        *ngIf="type === 'select' && multi"
        [placeholder]="placeholder"

        [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
        [class.is-valid]="control.touched && control.valid"
        [settings]="{
        singleSelection: false,
        selectAllText: 'forms.multiselect.select_all' | translate,
        unSelectAllText: 'forms.multiselect.unselect_all' | translate,
        noDataAvailablePlaceholderText: 'forms.multiselect.no_data_available' | translate,
        noFilteredDataAvailablePlaceholderText: 'forms.multiselect.no_filtered_data_available' | translate,
        searchPlaceholderText: 'forms.multiselect.search_placeholder' | translate,
        idField: 'value',
        textField: 'key',
        disabledField: 'disabled',
        enableCheckAll: true,
        allowSearchFilter: true,
        clearSearchFilter: false,
        maxHeight: 300,
        closeDropDownOnSelection: false,
        showSelectedItemsAtTop: true,
        defaultOpen: false,
        allowRemoteDataSearch: false,
        limitSelection: -1

      }"
        [data]="selectOptions"
        class="w-100"
        [class.form-control-sm]="small"
        [id]="label"
        [formControl]="control"
      >

      </ng-multiselect-dropdown>


      <input class="form-control" type="file" [class.form-control-sm]="small" *ngIf="type === 'file'" [id]="label"
             [formControl]="control"
             [class.is-invalid]="!!control.getError('serverError')">

      <span *ngIf="type === 'password'" [class.form-control-sm]="small"  class="input-group-text pointer"
            [class.is-invalid]="!!control.getError('serverError')"
            (click)="showPassword = !showPassword">
        <i class="fa fas fa-eye " *ngIf="!showPassword"></i>
        <i class="fa fas fa-eye-slash " *ngIf="showPassword"></i>
    </span>


      <div class="invalid-feedback" *ngIf="!!control.getError('serverError')">{{ control.getError('serverError') }}</div>


      <ng-container *ngFor="let err of control.errors | keyvalue">
        <ng-container *ngIf="(control.touched && control.invalid)">
          <div *ngIf="errorMessages && errorMessages[err.key] " class="invalid-feedback">
            {{ errorMessages[err.key] }}
          </div>
          <div *ngIf="(!errorMessages || !errorMessages[err.key] ) && err.key !== 'serverError'" class="invalid-feedback">
            {{ 'forms.errors.' + err.key | translate }}

            <ng-container *ngIf="err.key === 'min'">{{numberMin}}</ng-container>
            <ng-container *ngIf="err.key === 'max'">{{numberMax}}</ng-container>
          </div>
        </ng-container>

      </ng-container>
    </div>
  </div>
</div>
